import { AddCircle, Cancel, CheckCircle, Create, Search } from "@mui/icons-material"
import Grid from "@mui/material/Unstable_Grid2/Grid2"
import { useState, useContext, useEffect } from "react"
import ConfirmModal from "../../../Components/ConfirmModal/ConfirmModal"
import OneButton from "../../../Components/OneButton/OneButton"
import OneInput from "../../../Components/OneInput/OneInput"
import OneTable from "../../../Components/OneTable/OneTable"
import { WebSocketContext } from "../../../Providers/WebSocket/WebSocketContext"
import { filtroTextoPesquisa, showNotify } from "../../../Utils/Utils"
import { CadastroFechamento } from "./CadastroFechamento/CadastroFechamento"

const FechamentoConfig = () => {
    const [openCadastro, setOpenCadastro] = useState(false)
    const [idToEdit, setIdToEdit] = useState(null)

    const tableColumns = [
        {
            name: 'Código',
            selector: row => row.numero,
            grow: 0.4
        },
        {
            name: 'Título',
            selector: row => row.titulo,
            grow: 3
        },
        {
            name: 'Texto',
            selector: row => row.descricao,
            grow: 10
        },
        {
            name: 'Ativo',
            selector: row => row.ativo ? <CheckCircle sx={{ color: "green" }} /> : <Cancel sx={{ color: "red" }}/>
        },
        {
            name: 'Editar',
            cell: (row) => <Create sx={{ cursor: 'pointer' }} onClick={() => { editFechamento(row.id) }}/>,
            button: true
        }
    ]

    const { sendWs, addRoute } = useContext(WebSocketContext)

    const [filterText, setFilterText] = useState('')
    const [textToSearch, setTextToSearch] = useState('')
    const [loading, setLoading] = useState(false)
    const [fechamentoList, setFechamentoList] = useState(false)
    const filteredDataList = filtroTextoPesquisa(fechamentoList, filterText, ['titulo', 'descricao'])

    const [confirmDelete, setConfirmDelete] = useState(false)
    const [deleteIdFechamento, setDeleteIdFechamento] = useState(null)

    const handleSearch = (event) => {
        event.preventDefault()
        setFilterText(textToSearch)
    }

    const handleChange = (event) => {
        setTextToSearch(event.target.value)
    }

    const getWsResponse = (msg) => {
        setFechamentoList(msg.data.fechamento)
        setLoading(true)
    }

    useEffect(() => {
        addRoute("buscarTodosFechamentos", getWsResponse)
        sendWs("buscarTodosFechamentos")
    }, [])

    const editFechamento = (id) => {
        setIdToEdit(id)
        setOpenCadastro(true)
    }

    const getDeleteResponse = (msg) => {
        if (msg.data.status) {
            showNotify("success", "Fechamento deletada com sucesso")
            sendWs("buscarTodosFechamentos")
            setConfirmDelete(false)
            setDeleteIdFechamento(null)
        } else {
            showNotify("error", msg.data.message)
            setConfirmDelete(false)
        }
    }

    const deleteFechamento = () => {
        addRoute("deleteFechamento", getDeleteResponse)
        sendWs("deleteFechamento", { id: deleteIdFechamento })
    }

    return (
        <Grid xs={12} sx={{ width: '100%', height: '100%', display: 'flex', flexFlow: 'column' }} flexDirection="column" rowGap={1}>
            {openCadastro &&
            <CadastroFechamento
                openCadastro={openCadastro}
                setOpenCadastro={setOpenCadastro}
                idToEdit={idToEdit}
                setIdToEdit={setIdToEdit}
            />
            }
            {confirmDelete &&
                <ConfirmModal
                    titleText="Deletar Texto de Fechamento"
                    open={confirmDelete}
                    text="Você deseja deletar o texto de Fechamento?"
                    setOpen={setConfirmDelete}
                    cancelFunction={() => setConfirmDelete(false)}
                    confirmFunction={deleteFechamento}
                />
            }
            <Grid container xs={12} sx={{ alignItems: 'center', height: '50px' }}>
                <Grid xs={12} sm={6}>
                    <form
                        onSubmit={handleSearch}
                    >
                        <Grid container columnGap={1} xs={12} sx={{ alignItems: 'center' }}>
                            <Grid xs={6} sm={7.5}>
                                <OneInput name="pesquisar" onChange={handleChange} />
                            </Grid>
                            <Grid xs={4} sm={4}>
                                <OneButton
                                    id="button_teste"
                                    color="one_primary"
                                    variant="contained"
                                    type="submit"
                                    IconStart={Search}
                                >
                                     Pesquisar
                                </OneButton>
                            </Grid>
                        </Grid>
                    </form>
                </Grid>
                <Grid xs={6} sx={{ alignItems: 'center' }}>
                    <Grid container justifyContent="flex-end">
                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'flex-end' }}>
                            <OneButton
                                id="button_teste"
                                color="one_primary"
                                variant="contained"
                                onClick={() => { setIdToEdit(null); setOpenCadastro(true) }}
                                type="submit"
                                IconStart={AddCircle}
                                disabled={(!fechamentoList || fechamentoList.length >= 10)}
                                sx={{ maxWidth: '95px' }}
                            >
                                Novo
                            </OneButton>
                            <div style={{ display: 'flex', fontSize: '10px', color: 'red', marginTop: '2px' }}>
                                {fechamentoList.length >= 10 ? 'Limite máximo de 10 cadastros atingido' : ''}
                            </div>
                        </div>
                    </Grid>
                </Grid>
            </Grid>

            <Grid container xs={12} sx={{
                // padding: '5px',
                backgroundColor: '#D9D9D9',
                borderRadius: '5px',
                display: 'flex',
                flexGrow: 1,
                flexBasis: 'auto'
                // overflowY: 'scroll',
                // "::-webkit-scrollbar": {
                //     width: "6px",
                //     borderRadius: '5px'
                // },
                // "::-webkit-scrollbar-track": {
                //     background: "#D9D9D9",
                //     borderRadius: '5px'
                // },
                // "::-webkit-scrollbar-thumb": {
                //     background: "#888",
                //     borderRadius: '5px'
                // },
                // "::-webkit-scrollbar-thumb:hover": {
                //     background: "#555",
                //     borderRadius: '5px'
                // }
            }}>
                {fechamentoList &&
                <OneTable
                    columns={tableColumns}
                    data={filteredDataList}
                    progressPending={!loading}
                    dobleClickCallback={editFechamento}
                    // pagination
                    // paginationPerPage={rowsPage}
                    // paginationRowsPerPageOptions={[rowsPage, 5, 10, 15, 20, 25, 30]}
                    // paginationComponentOptions={ { rangeSeparatorText: "de", rowsPerPageText: 'Itens por página' } }
                />
                }
            </Grid>
        </Grid>
    )
}

export default FechamentoConfig
